// extracted by mini-css-extract-plugin
export default {"card":"tooltip-card_card__iLnoV"};